/* ATP Checkout: tapping Check out shows a seed dropping and "Planting your tree..." for under a second, then checkout opens. */
(function () {
  'use strict';
  var w = window, d = document;
  var reduce = w.matchMedia && w.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var editor = !!(w.Shopify && w.Shopify.designMode);
  var rng = function (seed) { return function () { seed |= 0; seed = (seed + 0x6d2b79f5) | 0; var t = Math.imul(seed ^ (seed >>> 15), 1 | seed); t = (t + Math.imul(t ^ (t >>> 7), 61 | t)) ^ t; return ((t ^ (t >>> 14)) >>> 0) / 4294967296; }; };
  var fmt = function (n) { return Math.round(n).toLocaleString('en-US'); };
  var once = function (el, cb, margin) {
    if (!('IntersectionObserver' in w)) { cb(); return; }
    var io = new IntersectionObserver(function (es) { if (es[0].isIntersecting) { io.disconnect(); cb(); } }, { rootMargin: margin || '0px 0px -12% 0px' });
    io.observe(el);
  };

  /* ---------- 3. Checkout button: "Planting your tree..." ---------- */
  function initCheckout() {
    d.addEventListener('click', function (e) {
      var b = e.target && e.target.closest && e.target.closest('button[name="checkout"]');
      if (!b || b.disabled || b.__atpGo || reduce || editor) return;
      var f = b.form;
      if (!f) return;
      e.preventDefault();
      b.__atpGo = true;
      b.__atpHTML = b.innerHTML;
      b.classList.add('atp-checkout-plant');
      b.innerHTML = '<span class="atp-cp"><span class="atp-cp__seed" aria-hidden="true"></span><span class="atp-cp__txt">Planting your tree\u2026</span></span>';
      setTimeout(function () {
        if (f.requestSubmit) f.requestSubmit(b);
        else { var h = d.createElement('input'); h.type = 'hidden'; h.name = 'checkout'; h.value = '1'; f.appendChild(h); f.submit(); }
      }, 700);
    }, true);
    // coming back with the browser back button: put the button text back
    w.addEventListener('pageshow', function () {
      Array.prototype.forEach.call(d.querySelectorAll('button[name="checkout"]'), function (b) {
        if (b.__atpGo) { b.innerHTML = b.__atpHTML; b.classList.remove('atp-checkout-plant'); b.__atpGo = false; }
      });
    });
  }

  try { initCheckout(); } catch (e) {}
})();
